import { Box, SxProps, Theme } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { useGoogleTagManager } from "./hooks/useGoogleTagManager";
import { TopPage } from "./page/TopPage/TopPage";
import { AmspPage } from "./page/AmspPage/AmspPage";
import { TasPage } from "./page/TasPage/TasPage";
import { RecruitPage } from "./page/RecruitPage/RecruitPage";

export const App = () => {
  // GTM 用の処理を実行
  useGoogleTagManager();

  return (
    <Box className="App" sx={sx}>
      <Routes>
        {/* トップページ */}
        <Route path="/" element={<TopPage />} />
        {/* TASページ */}
        <Route path="/tas" element={<TasPage />} />
        {/* AMSPページ */}
        <Route path="/amsp" element={<AmspPage />} />
        {/* 採用ページ */}
        <Route path="/recruit" element={<RecruitPage />} />
      </Routes>
    </Box>
  );
};

const sx: SxProps<Theme> = {
  width: "100%",
  maxWidth: "100vw",
  overflowX: "hidden",
};
